import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(() => ({
  sceneInfoText: {
    fontSize: '18px',
    lineHeight: '21px',
  },
  descriptionWrapper: {
    display: 'flex',
    alignItems: 'baseline',
  },
  colorBlock: {
    display: 'inline-block',
    width: 10,
    height: 10,
    border: '1px solid rgba(0,0,0, 0.3)',
    marginLeft: 3,
  },
}))

export default useStyles
